import _classCallCheck from "/Users/stefan/www/pluralsight/d3quickgraph-react/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/stefan/www/pluralsight/d3quickgraph-react/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/stefan/www/pluralsight/d3quickgraph-react/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/stefan/www/pluralsight/d3quickgraph-react/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/stefan/www/pluralsight/d3quickgraph-react/node_modules/@babel/runtime/helpers/esm/inherits";
import TinyEmitter from 'tinyemitter';
import isObject from 'lodash/isObject';
import { isNonNegativeInteger, checkOptions, checkLineObject, checkPointObject, checkPointGroupObject, sides, isAxis } from './check';
import { createSvg, createAxis as _createAxis, calculateBounds as _calculateBounds, drawDataLine as _drawDataLine, drawGrid as _drawGrid, drawPoints, clearGrid as _clearGrid } from './draw';
/**
 * @class D3QuickGraph
 */

var D3QuickGraph =
/*#__PURE__*/
function (_TinyEmitter) {
  _inherits(D3QuickGraph, _TinyEmitter);

  /**
   * Checks the required options are set, and uses default options if other options are not specified.
   * Options object is cloned.  Use updateOptions method and then draw to update the graph.
   *
   * @param {GraphOptions} options
   */
  function D3QuickGraph(options) {
    var _this;

    _classCallCheck(this, D3QuickGraph);

    console.log('D3QuickGraph constructor');
    _this = _possibleConstructorReturn(this, _getPrototypeOf(D3QuickGraph).call(this));
    /**
     * @type {GraphOptions}
     * @private
     */

    _this.options = checkOptions(options); // console.log(JSON.stringify(this.options, null, 2))

    /**
     * @type {selection}
     * @private
     */

    _this.svg = createSvg(_this.options);
    /**
     * @type {object}
     * @private
     */

    _this.lines = {};
    /**
     * @type {object}
     * @private
     */

    _this.groups = {};
    /**
     * @type {array}
     * @private
     */

    _this.lineOrder = [];
    /**
     * @type {array}
     * @private
     */

    _this.groupOrder = [];
    /**
     * @type {Bounds}
     * @private
     */

    _this.bounds = {};
    return _this;
  }
  /**
   * Returns the SVGElement so styles such as border can be applied
   *
   * @returns {SVGElement}
   */


  _createClass(D3QuickGraph, [{
    key: "getSvg",
    value: function getSvg() {
      if (this.svg) {
        return this.svg.node();
      }
    }
    /**
     * Apply the new options to the existing elements: main-container, graph-container, and svg,
     * then redraw the graph.
     *
     * @public
     * @param {GraphOptions} options New graphOptions object
     * @param {boolean} autoDraw Set to false if you do not want the graph to be immediately redrawn
     * @returns {D3QuickGraph}
     */

  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var autoDraw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.options = checkOptions(options);
      this.options.updateSvg = true;
      createSvg(this.options);
      autoDraw && this.draw();
      return this;
    }
    /**
     * Insert lineObject at the index "at".
     * If "at" is < 0 or > current length, then lineObject is added to the topmost layer (end)
     *
     * @public
     * @param {LineObject} lineObject
     * @param {number} [at]
     * @returns {D3QuickGraph}
     * @throws if lineObject contains invalid properties
     */

  }, {
    key: "addDataLine",
    value: function addDataLine(lineObject, at) {
      checkLineObject(lineObject);
      this.lines[lineObject.name] = lineObject; // this.bounds = this.calculateBounds()

      var initialLength = this.lineOrder.length;
      var name = lineObject.name;
      var currentIndex = this.lineOrder.indexOf(name);

      if (currentIndex >= 0) {
        this.lineOrder.splice(currentIndex, 1, name);
      }

      if (isNonNegativeInteger(at) && at <= initialLength) {
        this.lineOrder.splice(at, 0, name);
      } else {
        this.lineOrder.push(name);
      }

      return this;
    }
    /**
     * * Remove lineObject with given name from this.lines
     * * Remove corresponding line path from svg
     * @public
     * @param {string} name name of lineObject
     * @returns {D3QuickGraph}
     */

  }, {
    key: "removeDataLine",
    value: function removeDataLine(name) {
      var currentIndex = this.lineOrder.indexOf(name);

      if (currentIndex >= 0) {
        this.lineOrder.splice(currentIndex, 1, name);
        this.clearDataLine(name);
      }

      delete this.lines[name];
      return this;
    }
    /**
     * Remove line object from the graph, but lineObject is not removed this.lines
     * @public
     * @param name
     * @returns {D3QuickGraph}
     */

  }, {
    key: "clearDataLine",
    value: function clearDataLine(name) {
      var currentIndex = this.lineOrder.indexOf(name);

      if (currentIndex >= 0) {
        name = name.replace('.', '\\.');
        var className = "path.line.".concat(name);
        var selection = this.svg.selectAll(className);

        if (!selection.empty()) {
          selection.remove();
        }
      }

      return this;
    }
    /**
     * Returns number of lines
     * @public
     * @returns {integer}
     */

  }, {
    key: "getNumberOfLines",
    value: function getNumberOfLines() {
      return this.lineOrder.length;
    }
    /**
     * Returns number of groups with points
     * @public
     * @returns {integer}
     */

  }, {
    key: "getNumberOfGroups",
    value: function getNumberOfGroups() {
      return this.groupOrder.length;
    }
    /**
     * Returns names of all lines in order of lowest to highest layer
     * @public
     * @returns {Array<string>}
     */

  }, {
    key: "getLineNames",
    value: function getLineNames() {
      return this.lineOrder.slice();
    }
    /**
     * Returns names of all groups of points in order of lowest to highest layer
     * @public
     * @returns {Array<string>}
     */

  }, {
    key: "getGroupNames",
    value: function getGroupNames() {
      return this.groupOrder.slice();
    }
    /**
     * Insert pointGroupObject at the index "at".
     * If "at" is < 0 or > current length, then pointGroupObject is added to the topmost layer (end)
     * @public
     * @param pointGroupObject
     * @param at
     * @returns {D3QuickGraph}
     * @throws if pointGroupObject contains invalid properties
     */

  }, {
    key: "addPointGroup",
    value: function addPointGroup(pointGroupObject, at) {
      // pointGroupObject = cloneDeep(pointGroupObject)
      checkPointGroupObject(pointGroupObject);

      if (!Array.isArray(pointGroupObject.data)) {
        pointGroupObject.data = [];
      }

      this.groups[pointGroupObject.name] = pointGroupObject;
      var initialLength = this.groupOrder.length;
      var name = pointGroupObject.name;
      var currentIndex = this.groupOrder.indexOf(name);

      if (currentIndex >= 0) {
        this.groupOrder.splice(currentIndex, 1, name);
      }

      if (isNonNegativeInteger(at) && at <= initialLength) {
        this.groupOrder.splice(at, 0, name);
      } else {
        this.groupOrder.push(name);
      }

      return this;
    }
    /**
     * Add pointObject to pointGroup, using pointObject.name
     * If "at" is < 0 or > current length, then pointObject is added to the topmost layer (end)
     * @public
     * @param pointObject
     * @param at
     * @returns {D3QuickGraph}
     * @throws if pointObject contains invalid properties
     */

  }, {
    key: "addPoint",
    value: function addPoint(pointObject, at) {
      checkPointObject(pointObject);
      var name = pointObject.name;

      if (this.groups.indexOf(name) < 0) {
        this.addPointGroup({
          name: name
        });
      }

      var pointGroupObject = this.groups[name];
      var data = pointGroupObject.data;
      var initialLength = data.length;

      if (isNonNegativeInteger(at) && at <= initialLength) {
        data.splice(at, 0, name);
      } else {
        data.push(name);
      }

      return this;
    }
    /**
     * Remove pointGroup object from this.groups and remove from graph
     * @public
     * @param name
     * @returns {D3QuickGraph}
     */

  }, {
    key: "removePointGroup",
    value: function removePointGroup(name) {
      var currentIndex = this.groupOrder.indexOf(name);

      if (currentIndex >= 0) {
        this.clearPointGroup(name);
        this.groupOrder.splice(currentIndex, 1);
      }

      delete this.groups[name];
      return this;
    }
    /**
     * Remove pointGroup from graph, but does not remove from this.groups
     * @public
     * @param name
     * @returns {D3QuickGraph}
     */

  }, {
    key: "clearPointGroup",
    value: function clearPointGroup(name) {
      var currentIndex = this.groupOrder.indexOf(name);

      if (currentIndex >= 0) {
        var groupName = ".group-".concat(name);
        var selection = this.svg.selectAll(groupName);

        if (!selection.empty()) {
          selection.remove();
        }
      }

      return this;
    }
    /**
     * Remove pointObject from pointGroup that is at index i, and remove from graph
     * All remaining points in pointGroup are renumbered from 0 to length - 1
     * @public
     * @param name
     * @param i
     * @returns {D3QuickGraph}
     */

  }, {
    key: "removePoint",
    value: function removePoint(name, i) {
      var currentIndex = this.groupOrder.indexOf(name);

      if (currentIndex >= 0) {
        var pointGroup = this.groups[name];
        if (!pointGroup) return;
        checkPointGroupObject(pointGroup);
        var point = pointGroup.data[i];
        if (!point) return;
        pointGroup.data.splice(i, 1);
        this.clearPointGroup(name);
        this.drawPointGroup(name);
      }

      return this;
    }
    /**
     * Remove all lines from graph and from this.lines and this.lineOrder
     */

  }, {
    key: "removeAllLines",
    value: function removeAllLines() {
      var _this2 = this;

      var names = this.getLineNames();
      names.forEach(function (name) {
        _this2.removeDataLine(name);
      });
      return this;
    }
    /**
     * Remove all points from graph and from this.groups and this.groupOrder
     */

  }, {
    key: "removeAllPoints",
    value: function removeAllPoints() {
      var _this3 = this;

      var names = this.getGroupNames();
      names.forEach(function (name) {
        _this3.removePointGroup(name);
      });
      return this;
    }
    /**
     * * Calculate bounds of graph from all lines and pointGroups.
     * * To set an edge to a fixed value, set value in options.axisRounding
     * @public
     * @returns {D3QuickGraph}
     */

  }, {
    key: "calculateBounds",
    value: function calculateBounds() {
      var lines = this.lines,
          groups = this.groups;
      /**
       * @type {Bounds}
       * @private
       */

      this.bounds = _calculateBounds({
        lines: lines,
        groups: groups,
        axisRounding: this.options.axisRounding
      });
      return this;
    }
    /**
     * Returns a copy of this.bounds
     * @public
     * @returns {Bounds}
     */

  }, {
    key: "getBounds",
    value: function getBounds() {
      if (!isObject(this.bounds)) {
        this.calculateBounds();
      }

      return this.bounds.slice(0);
    }
    /**
     * Adds tick markers to both sides of x and y axes
     * @public
     * @returns {D3QuickGraph}
     */

  }, {
    key: "createAxis",
    value: function createAxis() {
      this.calculateBounds();

      var _createAxis2 = _createAxis(this.svg, this.options, this.bounds),
          axis = _createAxis2.axis,
          scale = _createAxis2.scale;

      Object.assign(this, {
        axis: axis,
        scale: scale
      });
      return this;
    }
    /**
     * Return the axis for specified side.
     *
     * @param {string} side
     * @returns {d3.axis}
     * @throws if axes have not yet been created or side is not top, right, bottom, or left
     */

  }, {
    key: "getAxis",
    value: function getAxis(side) {
      if (!this.axis) {
        throw new Error('getAxis: must call draw or createAxis first');
      } else if (!sides.includes(side)) {
        throw new Error("getAxis: invalid side \"".concat(side, " must be one of ").concat(sides.toString(), "\""));
      }

      return this.axis[side];
    }
  }, {
    key: "updateAxis",
    value: function updateAxis(axis, side) {
      if (!this.axis) {
        throw new Error('updateAxis: must call draw or createAxis first');
      } else if (!isAxis(axis)) {
        throw new Error('updateAxis: axis is not a d3.axis object');
      } else if (!sides.includes(side)) {
        throw new Error("updateAxis: invalid side \"".concat(side, " must be one of ").concat(sides.toString(), "\""));
      } else {
        this.svg.selectAll("g.axis-".concat(side)).call(axis);
      }
    }
    /**
     * * LineObject with given name must already exist in this.line{}
     * * If there was a previous path on the graph with the same name, it is removed first
     * * Draw lineObject on graph
     * @public
     * @param name
     * @returns {D3QuickGraph}
     */

  }, {
    key: "drawDataLine",
    value: function drawDataLine(name) {
      var lineObject = this.lines[name];

      if (!isObject(lineObject) || !Array.isArray(lineObject.data)) {
        throw new Error("".concat(name, " is  not a valid lineObject"));
      }

      checkLineObject(lineObject);
      var canvas = this.svg;
      var scale = this.scale,
          options = this.options,
          bounds = this.bounds;
      this.clearDataLine(name);

      _drawDataLine({
        canvas: canvas,
        scale: scale,
        options: options,
        bounds: bounds,
        lineObject: lineObject
      });

      return this;
    }
    /**
     * * PointGroupObject with given name must already exist in this.groups{}
     * * If the pointGroup was already drawn, it is removed first
     * * Draw pointGroupObject on graph
     * @public
     * @param name
     * @returns {D3QuickGraph}
     */

  }, {
    key: "drawPointGroup",
    value: function drawPointGroup(name) {
      var scale = this.scale,
          options = this.options,
          bounds = this.bounds;
      var pointGroupObject = this.groups[name];

      if (!isObject(pointGroupObject) || !Array.isArray(pointGroupObject.data)) {
        throw new Error("".concat(name, " is  not a valid pointGroupObject"));
      }

      checkPointGroupObject(pointGroupObject);
      var canvas = this.svg;
      this.clearPointGroup(name);
      drawPoints({
        canvas: canvas,
        scale: scale,
        options: options,
        bounds: bounds,
        pointGroupObject: pointGroupObject
      });
      return this;
    }
    /**
     * Clear grid and draw grid
     * @public
     * @returns {D3QuickGraph}
     */

  }, {
    key: "drawGrid",
    value: function drawGrid() {
      var svg = this.svg,
          axis = this.axis,
          scale = this.scale,
          options = this.options,
          bounds = this.bounds;
      this.clearGrid();

      _drawGrid({
        canvas: svg,
        axis: axis,
        scale: scale,
        options: options,
        bounds: bounds
      });

      return this;
    }
    /**
     * Clear grid from graph
     * @public
     * @returns {D3QuickGraph}
     */

  }, {
    key: "clearGrid",
    value: function clearGrid() {
      var svg = this.svg;

      _clearGrid({
        canvas: svg
      });

      return this;
    }
    /**
     * Remove all children of the graph Svg
     * @public
     * @returns {D3QuickGraph}
     */

  }, {
    key: "clearSvg",
    value: function clearSvg() {
      this.svg.selectAll('*').remove();
      return this;
    }
    /**
     * * Clear the graph
     * * Add the axes
     * * Add the grid
     * * Draw all the lines
     * * Draw all the point groups
     * @public
     * @returns {D3QuickGraph}
     */

  }, {
    key: "draw",
    value: function draw() {
      var _this4 = this;

      this.clearSvg();
      this.createAxis();
      this.drawGrid();
      this.lineOrder.forEach(function (name) {
        _this4.drawDataLine(name);
      });
      this.groupOrder.forEach(function (name) {
        _this4.drawPointGroup(name);
      });
      return this;
    }
  }]);

  return D3QuickGraph;
}(TinyEmitter);

export default D3QuickGraph;